import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewGuardrailChipsSection } from '../../../../../services/gable/gable.service';

/**
 * `guardrail_chips` section — renders NOTHING by design (A6). The Figma
 * tightening pass dropped the safety-reassurance pill row; the component, kind,
 * and wire type are retained so the preview contract stays stable across
 * backend versions, but there is intentionally no visible output.
 */
@Component({
    selector: 'app-ap-guardrail-chips-section',
    templateUrl: './guardrail-chips-section.component.html',
    styleUrls: ['./guardrail-chips-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class ActionPreviewGuardrailChipsSectionComponent {
    @Input({ required: true }) section!: ActionPreviewGuardrailChipsSection;
}
